export default __webpack_public_path__ + "static/media/loader-transparent.f7efae6d.gif";